//Style includes
import '../scss/itermic.scss'


import * as $ from 'jquery'
import 'bootstrap'
import 'select2'
import 'icheck'


import '@/jquery.editable'
import CustomControls from "@/CustomControls";
import Helpers from "@/Helpers";
import Calculator from "@/Calculator";
import CornerSelect from "@/CornerSelect";
import VendorPlugins from "@/VendorPlugins";
import RALSelect from "@/RALSelect";
import MountSchemeSelect from "@/MountSchemeSelect";
import CasseteSelect from "@/CasseteSelect";
import TOITTSelect from "@/TOITTSelect";
import TOITFSelect from "@/TOITFSelect";
import KoeffsAndValues from "@/KoeffsAndValues";
import Reserve from "@/Reserve";
import Passp from "@/Passp";


jQuery(() => {
    new VendorPlugins();
    new CustomControls();
    new Helpers();
    new Calculator();

// popup dialog boxes
    new CornerSelect(["ITTC", "ITTBC", "ITTLC", "ITTBLC", "ITTZC", "ITTBZC"]);
    new RALSelect();
    new MountSchemeSelect();
    new CasseteSelect();
    new TOITTSelect();
    new TOITFSelect();
    new KoeffsAndValues();
    new Reserve();
    new Passp();
});
